// extracted by mini-css-extract-plugin
export default {"flex-column":"navLinks_flex-column__Z66GX","flex-row":"navLinks_flex-row__XoWEx","page-size":"navLinks_page-size__sCX94","button-link":"navLinks_button-link__DCC4-"};